import React from "react";

export const ObstacleContext = React.createContext({});
